<template lang="pug">
.v-help.help(v-if="data" )
	.container
		section.help__main-section(:style="{backgroundImage: data?.background ? `url(${data.background})` : '#FFFFFF' }")
			.help__main-section-cover
			.help__main-section-content
				h1.help__main-section-title(v-if="data.title" ) {{ data.title }}
				.help__main-section-subtitle(v-if="data.subtitle" ) {{ data.subtitle }}
				v-search-small.help__main-section-search(:data-source="data")
		section.help__faq-section
			h2.help__faq-section-title(v-if="data.sectionTitle" ) {{ data.sectionTitle }}
			v-accordion.help__faq-section-accordion(:data-source="data")

</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import VAccordion from '../components/v-accordion.vue';
export default {
	components: {
		'v-accordion': VAccordion
	},

	mixins: [
		sourceMixin,
	],

	data() {
		return {
			data: null
		};
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
};
</script>